import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { MemberAppDataService } from '../services';
import { GlobalDomOpsService } from '@acepteam/globalspack';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MemberAppResolve implements Resolve<any>{

  constructor(private service: MemberAppDataService, private globaldomops: GlobalDomOpsService) {}

  resolve(route: ActivatedRouteSnapshot) {    
    return this.service.GetMemberAppData().pipe(first()) //take(1) // To make the observable complete after the first emission;
  }

}
